"use client";

import dynamic from "next/dynamic";
import styles from "./page.module.css";
import { ProcedureHeader } from "./components";

// Lazy load các component sử dụng framer-motion để giảm bundle size ban đầu
const ProcedureStep = dynamic(() => import("./components/ProcedureStep"), {
  loading: () => null,
});

const ProcedureArrows = dynamic(() => import("./components/ProcedureArrows"), {
  loading: () => null,
});

const WhyChooseUs = dynamic(() => import("./components/WhyChooseUs"), {
  loading: () => null,
});

export default function QuyTrinhPage() {
  return (
    <section className={styles.procedureSection}>
      <div className={styles.procedureContainer}>
        <ProcedureHeader />

        <div className={styles.procedureGrid}>
          <ProcedureStep
            stepNumber={1}
            title="Phân tích nhu cầu"
            description="Chúng tôi bắt đầu bằng việc nghiên cứu kỹ lưỡng các yêu cầu, mục tiêu và thách thức cụ thể mà bạn đang gặp phải. Bằng cách lắng nghe ý kiến và tìm hiểu sâu về lĩnh vực của bạn, chúng tôi đảm bảo mọi giải pháp đề xuất đều xuất phát từ nhu cầu thực tế."
            imageSrc="/assets/sdtc-image/quy-trinh/Rectangle.svg"
            stepClass={styles.stepAnalysis}
          />

          <ProcedureStep
            stepNumber={2}
            title="Phát triển thiết kế"
            description="Giai đoạn phát triển thiết kế tập trung vào việc hiện thực hóa các ý tưởng sáng tạo, kết hợp giữa thẩm mỹ và chức năng để tạo ra những giải pháp hoàn hảo. Đội ngũ của chúng tôi không chỉ chú trọng vào việc xây dựng giao diện đẹp mắt mà còn đảm bảo sự thân thiện với người dùng."
            imageSrc="/assets/sdtc-image/quy-trinh/Rectangle1.svg"
            stepClass={styles.stepDesign}
          />

          <ProcedureStep
            stepNumber={3}
            title="Đánh giá và tối ưu hóa"
            description="Trong giai đoạn triển khai, chúng tôi tập trung vào việc chuyển đổi các ý tưởng và thiết kế thành những sản phẩm thực tế, đáp ứng đầy đủ các yêu cầu kỹ thuật và chiến lược đã thống nhất. Quy trình triển khai được tối ưu hóa để đảm bảo tiến độ nhanh chóng và hiệu quả cao."
            imageSrc="/assets/sdtc-image/quy-trinh/Rectangle3.svg"
            stepClass={styles.stepOptimization} 
            />

          <ProcedureStep
            stepNumber={4}
            title="Triển khai giải pháp"
            description="Sau khi triển khai, chúng tôi không dừng lại ở việc bàn giao sản phẩm mà tiếp tục đồng hành cùng bạn trong giai đoạn đánh giá và tối ưu hóa. Dựa trên các dữ liệu thu thập thực tế, chúng tôi tiến hành đo lường hiệu quả và đề xuất các điều chỉnh kịp thời."
            imageSrc="/assets/sdtc-image/quy-trinh/Rectangle2.svg"
            stepClass={styles.stepImplementation}
          />

          <ProcedureArrows />
        </div>

        <WhyChooseUs />
      </div>
    </section>
  );
}
